module.exports = __webpack_public_path__ + "static/masterDetail-c5a5e3813476f0573a09f2641caed954.gif";